import React from 'react'
import CardUI from '../../../../widgets/layout/CardUI.js'
import ButtonUI from '../../../../widgets/action/ButtonUI.js'
import InputHtmlTextSF from '../../../../widgets/form/InputHtmlTextSF.js'
import InputTextAreaSF from '../../../../widgets/form/InputTextAreaSF.js'
import './MasterTemplateTerm.css'

const MasterTemplateTermUI = ({ context, loan, title, templateTerm, onEditClick, editMode, onDevEditClick, devEditMode, value, onChange, error, setError, onUpdateCurrentVersionClick, onCreateNewVersionClick }) => {
  const isEditing = (editMode && !devEditMode) || (!editMode && devEditMode)

  return (
    <div className='mt_term_layout'>
    <CardUI className='mt_term_main' title={
      <span className='g_flex_h'>
        {title} Ver {templateTerm.templateValueList && templateTerm.templateValueList[templateTerm.templateValueList.length - 1].version}
        {
          context.permissions.includes('su_superuser') &&
          <span className='icon icon-pencil' onClick={onDevEditClick}>Dev Edit</span>
        }
        <span className='icon icon-pencil' onClick={onEditClick}> Edit</span>
      </span>
    }>
      <div className={`card ${isEditing ? 'mt_term_card_edit' : ''}`}>
        {
          editMode && !devEditMode &&
          <div className='mt_term_editor'>
            <div className='mt_term_editor_body'>
              <InputHtmlTextSF type='html' name='' label='' height='100%' withToolbar={true}
                value={value} onChange={onChange}
                error={error} setError={setError}
              />
            </div>
            <span className='g_flex_h g_flex_right mt_term_editor_footer'>
              {
                context.permissions.includes('su_superuser') &&
                ((loan && templateTerm.loanId !== 'master') || (!loan && templateTerm.loanId === 'master')) &&
                <ButtonUI
                  type='button'
                  label='Update current version'
                  onClick={onUpdateCurrentVersionClick}
                />
              }
              <span className='g_m_left_100'>
                <ButtonUI
                  type='button'
                  label='Create new version'
                  onClick={onCreateNewVersionClick}
                />
              </span>
            </span>
          </div>
        }
        {
          !editMode && devEditMode &&
          <div className='mt_term_editor'>
            <div className='mt_term_editor_body'>
              <InputTextAreaSF type='text' name='' label=''
                value={value} onChange={onChange}
                error={error} setError={setError}
              />
            </div>
            <span className='g_flex_h g_flex_right mt_term_editor_footer'>
              {
                context.permissions.includes('su_superuser') &&
                ((loan && templateTerm.loanId !== 'master') || (!loan && templateTerm.loanId === 'master')) &&
                <ButtonUI
                  type='button'
                  label='Update current version'
                  onClick={onUpdateCurrentVersionClick}
                />
              }
              <span className='g_m_left_100'>
                <ButtonUI
                  type='button'
                  label='Create new version'
                  onClick={onCreateNewVersionClick}
                />
              </span>
            </span>
          </div>
        }
        {
          !editMode && !devEditMode &&
          <span dangerouslySetInnerHTML={{ __html: templateTerm.templateValueList && templateTerm.templateValueList[templateTerm.templateValueList.length - 1].value }} />
        }
      </div>
    </CardUI>
    <CardUI className='mt_term_diff' title={
      <span>
        {
          templateTerm.updatedBy &&
          <span>Updated by {templateTerm.updatedBy}</span>
        }
      </span>
    }>
      <div className='card'>
        <span dangerouslySetInnerHTML={{ __html: templateTerm.diff }} />
      </div>
    </CardUI>
  </div>
  )
}

export default MasterTemplateTermUI
